import { ProjectStore } from './ProjectStore';
import { UIStore } from './UIStore';
import { HistoryStore } from './HistoryStore';
import { ToolManager } from '@/tools/ToolManager';

export class RootStore {
  projectStore: ProjectStore;
  uiStore: UIStore;
  historyStore: HistoryStore;
  toolManager: ToolManager;

  constructor() {
    this.uiStore = new UIStore();
    this.historyStore = new HistoryStore();
    this.projectStore = new ProjectStore(this.historyStore, this.uiStore);
    this.toolManager = new ToolManager(this);

    this.projectStore.init(this);
    this.historyStore.init(this);
    this.uiStore.init(this);
  }
}
